import type { IntegrationConfig } from 'modules/Integrations/domain'
import logo from './numeralLogo.png'
import { NumeralIntegrationDetail } from 'Integrations/integrationsConfig/numeral/NumeralIntegrationDetail'
import { NumeralConfigurationManagement } from 'Integrations/integrationsConfig/numeral/NumeralConfigurationManagement/NumeralConfigurationManagement'
import { numeralConfigurationLoader } from 'Integrations/integrationsConfig/numeral/numeral.loader'
import { numeralConfigurationMutator } from 'Integrations/integrationsConfig/numeral/numeral.mutator'

export const numeralIntegrationConfig: IntegrationConfig = {
  logoUrl: logo,
  smallLogoUrl: logo,
  statusLabel: null,
  documentationUrl: 'https://docs.sequencehq.com/connectors/numeral',
  title: 'Numeral',
  features: {
    canDeleteLinks: false,
    canUninstall: false,
    isDocumentationOnly: false,
    disableSubmitUntilValid: true
  },
  description:
    'Compliance platform for automated sales tax calculations, filing, and reporting.',
  components: {
    detail: NumeralIntegrationDetail,
    management: NumeralConfigurationManagement
  },
  communication: {
    configuration: {
      loader: numeralConfigurationLoader,
      mutator: numeralConfigurationMutator
    }
  }
}

export type NumeralIntegrationConfig = {
  apiKey?: string
  obfuscatedApiKey: string
}
